import { useSnackbar } from "@durlabh/dframework-ui";
import { releaseManagementConfig } from "./ReleaseManagementModel";
import { UiModel } from '@durlabh/dframework-ui';

const releaseManagement = new UiModel(releaseManagementConfig);

const statusMessageMap = {
    118: 'Production',
    117: 'Lock For Approval'
};

const ReleaseManagementForm = (props) => {
    const { showMessage } = useSnackbar();
    const beforeFormSubmit = ({ formik }) => {
        const { RevisionStatusId: revisionStatusId } = formik.values;
        if (revisionStatusId in statusMessageMap) {
            showMessage('Note', `Processing your ${statusMessageMap[revisionStatusId]} request, may take upto 10 seconds`, 'info');
        }
    };
    return <releaseManagement.Form beforeSubmit={beforeFormSubmit} {...props} />;
};

export default ReleaseManagementForm;